import "./Footer.scss";

import { useTranslation } from "react-i18next";

import { SITE_URL } from "@/config/site";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <span className="network">{t("footer.network")}</span>
      <span className="aksara">
        <a href={SITE_URL} target="_blank" rel="noreferrer noopener">
          {t("footer.aksara")}
        </a>
      </span>
    </footer>
  );
};

export default Footer;
